var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 178,
    viewBox: "0 0 195 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M191.225 0H3.10087C1.38837 0 0 1.38799 0 3.10087V174.687C0 176.399 1.38837 177.787 3.10087 177.787H191.225C192.938 177.787 194.326 176.399 194.326 174.687V3.10087C194.326 1.38799 192.938 0 191.225 0ZM6.20173 6.20211H157.115V24.8077H6.20173V6.20211ZM188.124 171.586H6.20173V31.0094H188.124V171.586ZM188.124 24.8077H163.317V6.20211H188.124V24.8077Z",
    fill: "url(#paint0_linear_9_259)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M178.821 37.2115H15.5047C13.7922 37.2115 12.4038 38.5995 12.4038 40.3124V137.475C12.4038 139.188 13.7922 140.576 15.5047 140.576C17.2172 140.576 18.6055 139.188 18.6055 137.475V43.4133H175.72V159.182H18.6055V149.879C18.6055 148.166 17.2172 146.778 15.5047 146.778C13.7922 146.778 12.4038 148.166 12.4038 149.879V162.283C12.4038 163.996 13.7922 165.384 15.5047 165.384H178.821C180.534 165.384 181.922 163.996 181.922 162.283V40.3124C181.922 38.5995 180.534 37.2115 178.821 37.2115Z",
    fill: "url(#paint1_linear_9_259)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M175.721 18.6056C177.433 18.6056 178.821 17.2173 178.821 15.5047C178.821 13.7922 177.433 12.4039 175.721 12.4039C174.008 12.4039 172.62 13.7922 172.62 15.5047C172.62 17.2173 174.008 18.6056 175.721 18.6056Z",
    fill: "url(#paint2_linear_9_259)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1629 57.4708C87.7673 57.4708 78.8075 60.4035 71.2515 65.9509C69.8711 66.9647 69.5732 68.9057 70.5869 70.2857C71.6007 71.6665 73.5421 71.9637 74.9217 70.9503C81.4058 66.1893 89.0972 63.6729 97.1629 63.6729C117.91 63.6729 134.788 80.5512 134.788 101.298C134.788 122.044 117.91 138.923 97.1629 138.923C76.4163 138.923 59.5381 122.044 59.5381 101.298C59.5381 93.2317 62.0544 85.5407 66.8154 79.0565C67.8292 77.6761 67.5316 75.7355 66.1512 74.7218C64.7708 73.7092 62.8298 74.0056 61.8165 75.3864C56.2683 82.9419 53.3359 91.9022 53.3359 101.298C53.3359 125.464 72.9963 145.124 97.1625 145.124C121.328 145.124 140.989 125.464 140.989 101.298C140.989 77.1319 121.329 57.4708 97.1629 57.4708Z",
    fill: "url(#paint3_linear_9_259)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M101.548 101.298L116.459 86.387C117.67 85.1755 117.67 83.2125 116.459 82.0014C115.248 80.7907 113.285 80.7907 112.074 82.0014L97.1628 96.9121L82.2521 82.0014C81.041 80.7907 79.0776 80.7907 77.8668 82.0014C76.6557 83.2129 76.6557 85.1759 77.8668 86.387L92.7772 101.298L77.8668 116.208C76.6557 117.42 76.6557 119.383 77.8668 120.594C78.4722 121.199 79.2658 121.502 80.0595 121.502C80.8531 121.502 81.6467 121.199 82.2521 120.594L97.1628 105.683L112.073 120.594C112.679 121.199 113.472 121.502 114.266 121.502C115.059 121.502 115.853 121.199 116.459 120.594C117.67 119.383 117.67 117.42 116.459 116.208L101.548 101.298Z",
    fill: "url(#paint4_linear_9_259)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_259",
    x1: 194.326,
    y1: 90.217,
    x2: -5.607e-7,
    y2: 90.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB7722"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9_259",
    x1: 181.922,
    y1: 102.252,
    x2: 12.4038,
    y2: 102.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB7722"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9_259",
    x1: 178.821,
    y1: 15.5509,
    x2: 172.62,
    y2: 15.5509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB7722"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9_259",
    x1: 140.989,
    y1: 101.95,
    x2: 53.3359,
    y2: 101.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB7722"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9_259",
    x1: 117.367,
    y1: 101.598,
    x2: 76.9585,
    y2: 101.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB7722"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.29559f9991019ca0b5cc0e91af4c5043.svg";
export { ForwardRef as ReactComponent };